<template>
    <section>
        <div class="container imageContainer" id="media">
            <div class="row" style="margin-right: 0px; margin-left: 0px;">
                <div class="col-sm-4 col-xs-4 images img-wrapper">
                    <img v-lazy="imgUrl1" alt="dwerve" v-on:click="openModal();currentSlide(1)" class="hvr-pulse-grow">
                </div>
                <div class="col-sm-4 col-xs-4 images img-wrapper">
                  <img v-on:click="openModal();currentSlide(2)" class="hvr-pulse-grow " v-lazy="imgUrl2" alt="dwerve">
                    
                </div>
                <div class="col-sm-4  col-xs-4 images img-wrapper">
                    <img v-on:click="openModal();currentSlide(3)" class="hvr-pulse-grow " v-lazy="imgUrl3" alt="dwerve">
                </div>
               
            </div>
            <div class="row" style="margin-right: 0px; margin-left: 0px;">
               <div class="col-sm-4 col-xs-4 images img-wrapper">
                    <img v-on:click="openModal();currentSlide(4)" class="hvr-pulse-grow" v-lazy="imgUrl4" alt="dwerve">
                </div>
                <div class="col-sm-4 col-xs-4 images img-wrapper">
                    <img v-on:click="openModal();currentSlide(5)" class="hvr-pulse-grow" v-lazy="imgUrl5" alt="dwerve">
                </div>
                <div class="col-sm-4 col-xs-4 images img-wrapper">
                    <img v-on:click="openModal();currentSlide(6)" class="hvr-pulse-grow" v-lazy="imgUrl6" alt="dwerve">
                </div>

            </div>
           
        </div>
        <div id="myModal" class="modal">
        <span class="close cursor" v-on:click="closeModal()">&times;</span>
        <div class="modal-content">

            <div class="mySlides">
            <div class="numbertext">1 / 6</div>
            <img src="/static/assets/images/Dwerve-Screenshot-0.jpg" style="width:100%" alt="dwerve">
            </div>

            <div class="mySlides">
            <div class="numbertext">2 / 6</div>
            <img src="/static/assets/images/Dwerve-Screenshot-5.jpg" style="width:100%" alt="dwerve">
            </div>

            <div class="mySlides">
            <div class="numbertext">3 / 6</div>
            <img src="/static/assets/images/Dwerve-Screenshot-3.jpg" style="width:100%" alt="dwerve">
            </div>

            <div class="mySlides">
            <div class="numbertext">4 / 6</div>
            <img src="/static/assets/images/Dwerve-Screenshot-4.jpg" style="width:100%" alt="dwerve">
            </div>

            <div class="mySlides">
            <div class="numbertext">5 / 6</div>
            <img src="/static/assets/images/Dwerve-Screenshot-2.jpg" style="width:100%" alt="dwerve">
            </div>

            <div class="mySlides">
            <div class="numbertext">6 / 6</div>
            <img src="/static/assets/images/Dwerve-Screenshot-1.jpg" style="width:100%" alt="dwerve">
            </div>


            <!-- Next/previous controls -->
            <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
            <a class="next" v-on:click="plusSlides(1)">&#10095;</a>

        </div>
        </div>
    </section>
</template>

<script>
export default {
    data: function() {
    return {
      imgUrl1: '/static/assets/images/Dwerve-Screenshot-0.jpg',
      imgUrl2: '/static/assets/images/Dwerve-Screenshot-5.jpg',
      imgUrl3: '/static/assets/images/Dwerve-Screenshot-3.jpg',
      imgUrl4: '/static/assets/images/Dwerve-Screenshot-4.jpg',
      imgUrl5: '/static/assets/images/Dwerve-Screenshot-2.jpg',
      imgUrl6: '/static/assets/images/Dwerve-Screenshot-1.jpg',

    };
  },
  slideIndex: 1,
  methods: {
    openModal() {
      document.getElementById("myModal").style.display = "block";
    },
    closeModal() {
      document.getElementById("myModal").style.display = "none";
    },
    plusSlides(n) {
      this.showSlides((this.slideIndex += n));
    },
    currentSlide(n) {
      this.showSlides((this.slideIndex = n));
    },
    showSlides(n) {
      var i;
      //   this.showSlides(this.slideIndex);
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("demo");
      var captionText = document.getElementById("caption");
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      // dots[this.slideIndex - 1].className += " active";
      // captionText.innerHTML = dots[this.slideIndex - 1].alt;
    }
  }
};
</script>


<style scoped>
.hover02 figure img {
  width: 300px;
  height: auto;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
.hover02 figure:hover img {
  width: 350px;
}
.parallaxImg {
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.galleryBackground {
  background: url("/static/assets/images/map.png");
}
.overlay:before {
  position: absolute;
  content: " ";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 0;
  background-color: rgba(0, 0, 0, 0.78);
}
.cta-title {
  font-family: Grandmaster;
  font-size: 26px;
  text-shadow: -2.4px -2.4px 0 #474043, -2.4px -1.4px 0 #474043,
    -2.4px -0.4px 0 #474043, -2.4px 0.6px 0 #474043, -2.4px 1.6px 0 #196090,
    -2.4px 2.6px 0 #474043, -1.4px -2.4px 0 #474043, -1.4px -1.4px 0 #474043,
    -1.4px -0.4px 0 #474043, -1.4px 0.6px 0 #474043, -1.4px 1.6px 0 #474043,
    -1.4px 2.6px 0 #474043, -0.4px -2.4px 0 #474043, -0.4px -1.4px 0 #474043,
    -0.4px -0.4px 0 #474043, -0.4px 0.6px 0 #474043, -0.4px 1.6px 0 #474043,
    -0.4px 2.6px 0 #474043, 0.6px -2.4px 0 #474043, 0.6px -1.4px 0 #474043,
    0.6px -0.4px 0 #474043, 0.6px 0.6px 0 #474043, 0.6px 1.6px 0 #474043,
    0.6px 2.6px 0 #474043, 1.6px -2.4px 0 #474043, 1.6px -1.4px 0 #474043,
    1.6px -0.4px 0 #474043, 1.6px 0.6px 0 #474043, 1.6px 1.6px 0 #474043,
    1.6px 2.6px 0 #474043, 2.6px -2.4px 0 #474043, 2.6px -1.4px 0 #474043,
    2.6px -0.4px 0 #474043, 2.6px 0.6px 0 #474043, 2.6px 1.6px 0 #474043,
    2.6px 2.6px 0 #474043;
}
hr.style-seven {
  height: 7px;
  border: 18px dashed #999999a3;
  margin-bottom: 55px;
}
.hr-pattern {
  margin-top: 55px;
  height: 7px;
  border: 18px dashed #999999a3;
}
.row > .column {
  padding: 0 8px;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Create four equal columns that floats next to eachother */
.column {
  float: left;
  width: 25%;
}

/* The Modal (background) */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #000000ba;
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  width: 90%;
  max-width: 1130px;
}

/* The Close Button */
.close {
  color: #f3fdfc;
  position: absolute;
  top: 100px;
  right: 179px;
  z-index: 999;
  font-size: 65px;
  font-weight: bold;
  opacity: 1.2 !important;
}

.close:hover,
.close:focus {
  color: #999;
  text-decoration: none;
  cursor: pointer;
}

/* Hide the slides by default */
.mySlides {
  display: none;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -50px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
  -webkit-user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* Caption text */
.caption-container {
  text-align: center;
  background-color: black;
  padding: 2px 16px;
  color: white;
}

img.demo {
  opacity: 0.6;
}

.active,
.demo:hover {
  opacity: 1;
}

img.hover-shadow {
  transition: 0.3s;
}

.hover-shadow:hover {
  box-shadow: -17px 20px 20px 20px rgb(0, 0, 0),
    0 6px 20px 0 rgba(0, 0, 0, 0.97);
}

.imageContainer {
  width: -webkit-fill-available;
  padding-right: 0px;
  padding-left: 0px;
  padding: 0px;
  top: 0;
  visibility: visible;
}

.images {
  padding-right: 0px;
  padding-left: 0px;
  overflow: hidden;
}

.img-wrapper {
  background-color: #000000cf;
}

.img-wrapper:hover img {
  opacity: 0.6;
  cursor: pointer;
}
@-webkit-keyframes hvr-pulse-grow {
  to {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
@keyframes hvr-pulse-grow {
  to {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
.hvr-pulse-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}
.hvr-pulse-grow:hover,
.hvr-pulse-grow:focus,
.hvr-pulse-grow:active {
  -webkit-animation-name: hvr-pulse-grow;
  animation-name: hvr-pulse-grow;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-direction: alternate;
  animation-direction: alternate;
}

.hvr-grow-shadow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow, transform;
  transition-property: box-shadow, transform;
}
.hvr-grow-shadow:hover,
.hvr-grow-shadow:focus,
.hvr-grow-shadow:active {
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media only screen and (max-width: 450px) {
  .close {
    top: 45px;
    right: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Images.vue